"use client";
import Image from "next/image";
import CheckCircle from "@/assets/icon/checkCircleIcon.svg?url";

const PLPStockStatus = ({
  t,
  homeDelivery = true,
  muteClickCollect = false,
}) => {
  if (!homeDelivery && muteClickCollect) return null;
  return (
    <>
      <Image
        width={20}
        height={20}
        unoptimized
        src={CheckCircle}
        alt="stock icon"
        className="max-w-[20px]"
      />
      <p className="text-body-text-3-sb  xs:text-body-text-3-m text-tertiary-green whitespace-nowrap">
        {homeDelivery ? t("product.in_stock") : t("product.collection_only")}
      </p>
    </>
  );
};

export default PLPStockStatus;
